// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"141":"b0e22b325aeda469","365":"d34dd677d5a9a5aa","874":"b0e22b325aeda469","964":"b0e22b325aeda469"}[chunkId] + ".css";
};